import React, { useState, useEffect } from "react";
import ChecklistCard from "../../ChecklistCard.js";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import FormControl from "@mui/material/FormControl";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import YTMultiRepCard from "../../YTMultiRepCard.js";
import YTMustRefer from "../../YTMustRefer.js";
import YTClauseCard from "../../YTClauseCard.js";
import clauseData from "../../../data/Yukon/clauseData.js";
import clauseCardDesc from "../../../data/Yukon/clauseCardDescription.js";
import importantNotes from "../../../data/Yukon/importantNotes.js";
import ImportantNotes from "../../ImportantNotes.js";
import BackToTop from "../../BackToTop.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";

export default function YTAgriPurchase() {
  const [BuyerDocs, setBuyerDocs] = useState([
    "Consumer Relationships Guide",
    "Agricultural Exclusive Buyer Representation Agreement",
    "Related FINTRAC Documents",
  ]);

  const [DealDocs, setDealDocs] = useState([
    "Agricultural Purchase Contract",
    "Addendums (if applicable)",
    "Copy of Deposit & Receipt",
  ]);

  const [SellerRep, setSellerRep] = useState("No");
  const [IsDisclosure, setIsDisclosure] = useState("No");
  const [ListingType, setListingType] = useState("MLS");
  const [BuyerRep, setBuyerRep] = useState("Client");

  const theme = createTheme({
    palette: {
      primary: {
        main: "#506CAA",
        dark: "#506CAA",
      },
      text: {
        primary: "#31303F",
        secondary: "#506CAA",
      },
    },
  });

  const checkSelections = () => {
    let newDocs = [...DealDocs];

    if (ListingType === "MLS") {
      newDocs.push("MLS Sheet (Full Agent Detail View)");
      if (IsDisclosure !== "No") {
        newDocs.push("Disclosure Requirements (see notes)");
      }
    } else if (ListingType === "Exclusive") {
      newDocs.push("Land Title");
      if (IsDisclosure !== "No") {
        newDocs.push("Disclosure Requirements (see notes)");
      }
    } else {
      return;
    }

    setDealDocs(newDocs);
  };

  useEffect(() => {
    checkSelections();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const addDisclosure = (e) => {
    setIsDisclosure(e.target.value);
    if (DealDocs.includes("Disclosure Requirements (see notes)") === true) {
      return;
    } else {
      setDealDocs([...DealDocs, "Disclosure Requirements (see notes)"]);
    }
  };

  const removeDisclosure = (e) => {
    setIsDisclosure(e.target.value);
    setDealDocs(
      DealDocs.filter((item) => item !== "Disclosure Requirements (see notes)")
    );
  };

  const setExclusive = (e) => {
    setListingType(e.target.value);
    if (DealDocs.includes("Land Title")) {
      return;
    } else {
      let newDocs = DealDocs.filter(
        (item) => item !== "MLS Sheet (Full Agent Detail View)"
      );
      newDocs.push("Land Title");
      setDealDocs(newDocs);
    }
  };

  const setMLS = (e) => {
    setListingType(e.target.value);
    if (DealDocs.includes("MLS Sheet (Full Agent Detail View)") === true) {
      return;
    } else {
      let newDocs = DealDocs.filter((item) => item !== "Land Title");
      newDocs.push("MLS Sheet (Full Agent Detail View)");
      setDealDocs(newDocs);
    }
  };

  const changeSellerRep = (e) => {
    if (ListingType === "FSBO") {
      setListingType("MLS");
    }
    setSellerRep(e.target.value);
    if (e.target.value === "No") {
      setBuyerRep("Client");
      setBuyerDocs([
        "Consumer Relationships Guide",
        "Agricultural Exclusive Buyer Representation Agreement",
        "Related FINTRAC Documents",
      ]);
    }
  };

  const changeBuyerRep = (e) => {
    setBuyerRep(e.target.value);
    if (e.target.value === "Client") {
      setBuyerDocs([
        "Consumer Relationships Guide",
        "Agricultural Exclusive Buyer Representation Agreement",
        "Related FINTRAC Documents",
      ]);
    } else {
      setBuyerDocs([
        "Consumer Relationships Guide",
        "Customer Acknowlegement Form",
        "Related FINTRAC Documents",
      ]);
    }
  };
  return (
    <div className="checklists w-full flex flex-col items-center justify-center">
      <div className="flex flex-col w-full pl-4 ">
        <div className="flex flex-col items-left pb-2">
          <div className="flex w-full pt-3 items-center ">
            <div className="pb-5 pr-3">
              <div className="float-left mr-3 pt-2">
                <FontAwesomeIcon
                  icon={faTriangleExclamation}
                  size="2xl"
                  color="#cc0000"
                />
              </div>
              <div>
                <strong>
                  Trading Agricultural Real Estate in Yukon requires a Rural
                  License. If you do not have this license, you cannot trade
                  agricultural real estate and must refer the client to an agent
                  with the appropriate license.
                </strong>
              </div>
            </div>
          </div>
          {ListingType === "FSBO" ? (
            <>
              <div className="paragraph pb-3">
                <p>
                  <strong>Important:</strong> <br />
                  It is important to ensure that you have completed the
                  Agricultural - Seller Customer Acknowledgement and Fee
                  Agreement before showing the property.
                </p>
              </div>
            </>
          ) : (
            ""
          )}
          <div className="pr-5 ">
            Do you also represent the Seller in this transaction?
          </div>
          <ThemeProvider theme={theme}>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                defaultValue="No"
              >
                <FormControlLabel
                  value="Yes"
                  control={<Radio size="small" onClick={changeSellerRep} />}
                  label="Yes"
                />
                <FormControlLabel
                  value="No"
                  control={<Radio size="small" onClick={changeSellerRep} />}
                  label="No"
                />
              </RadioGroup>
            </FormControl>
          </ThemeProvider>
          {SellerRep === "Yes" ? (
            <>
              <div className="pr-5 pt-5">Buyer's Choice?</div>
              <ThemeProvider theme={theme}>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    defaultValue="Client"
                  >
                    <FormControlLabel
                      value="Client"
                      control={<Radio size="small" onClick={changeBuyerRep} />}
                      label="Client"
                    />
                    <FormControlLabel
                      value="Customer"
                      control={<Radio size="small" onClick={changeBuyerRep} />}
                      label="Customer Status"
                    />
                  </RadioGroup>
                </FormControl>
              </ThemeProvider>
            </>
          ) : (
            ""
          )}

          <div className="pr-5 pt-5">Type of Listing?</div>
          <ThemeProvider theme={theme}>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                defaultValue="MLS"
                value={ListingType}
              >
                <div>
                  <FormControlLabel
                    value="MLS"
                    control={<Radio size="small" onClick={setMLS} />}
                    label="MLS"
                  />
                  <FormControlLabel
                    value="Exclusive"
                    control={<Radio size="small" onClick={setExclusive} />}
                    label="Exclusive"
                  />
                </div>
                {SellerRep === "No" && (
                  <>
                    <div>
                      <FormControlLabel
                        value="FSBO"
                        control={<Radio size="small" onClick={setExclusive} />}
                        label="For Sale By Owner"
                      />
                    </div>
                  </>
                )}
              </RadioGroup>
            </FormControl>
          </ThemeProvider>
          <div className="pr-5 pt-5">
            {SellerRep === "No"
              ? `Do you have any direct/indirect interest with respect to the Buyer in this transaction?`
              : `Do you have any direct/indirect interest with respect to the Buyer or Seller in this transaction?`}
          </div>
          <ThemeProvider theme={theme}>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                defaultValue="No"
              >
                <FormControlLabel
                  value="Personal Trade"
                  control={<Radio size="small" onClick={addDisclosure} />}
                  label="Personal Trade"
                />
                <FormControlLabel
                  value="Indirect"
                  control={<Radio size="small" onClick={addDisclosure} />}
                  label="Indirect Interest"
                />
                <FormControlLabel
                  value="No"
                  control={<Radio size="small" onClick={removeDisclosure} />}
                  label="No"
                />
              </RadioGroup>
            </FormControl>
          </ThemeProvider>
        </div>
      </div>
      {IsDisclosure === "Personal Trade" && ListingType === "FSBO" ? (
        <>
          <div className="flex w-full pl-4 pt-3 items-center ">
            <div className="pb-5 pr-3">
              <div className="float-left mr-3 pt-2">
                <FontAwesomeIcon
                  icon={faTriangleExclamation}
                  size="2xl"
                  color="#cc0000"
                />
              </div>
              <div>
                Although it is not explicitly forbidden, it is strongly advised
                that you recommend to the Seller that they seek representation
                elsewhere, as the potential conflict of interest may be too
                severe to ensure impartiality in this type of transaction.
              </div>
            </div>
          </div>
        </>
      ) : (
        ""
      )}
      {SellerRep === "Yes" &&
      IsDisclosure !== "No" &&
      !(BuyerRep === "Client" && IsDisclosure === "Personal Trade") ? (
        <>
          <div className="flex w-full pl-4 pt-3 items-center ">
            <div className="pb-5 pr-3">
              <div className="float-left mr-3 pt-2">
                <FontAwesomeIcon
                  icon={faTriangleExclamation}
                  size="2xl"
                  color="#cc0000"
                />
              </div>
              <div>
                Although it is not explicitly forbidden, it is strongly advised
                that you recommend to the Buyer that they seek representation
                with a different agent, as the potential conflict of interest
                may be too severe to ensure impartiality in this type of
                transaction.
              </div>
            </div>
          </div>
        </>
      ) : (
        ""
      )}

      {SellerRep === "Yes" &&
      IsDisclosure === "Personal Trade" &&
      BuyerRep === "Client" ? (
        <YTMustRefer IsMLS={ListingType} />
      ) : ListingType === "FSBO" ? null : (
        <>
          {SellerRep === "Yes" && BuyerRep === "Client" ? (
            <YTMultiRepCard />
          ) : (
            ""
          )}
          <ChecklistCard
            province={"YT"}
            CheckListData={BuyerDocs}
            CheckListData2={DealDocs}
            Header={"Purchase:"}
            Header2={"Buyer is a " + BuyerRep}
            Title1="Buyer Documents"
            Title2="Deal Documents"
          />
        </>
      )}

      {ListingType === "FSBO" ? (
        <ChecklistCard
          province={"YT"}
          CheckListData={BuyerDocs}
          CheckListData2={[
            "Consumer Relationships Guide",
            "Agricultural Seller Customer Acknowledgement and Fee Agreement",
            "Seller Related FINTRAC Documents",
          ]}
          CheckListData3={DealDocs}
          Header={"Purchase:"}
          Header2={"Buyer is a " + BuyerRep}
          Title1="Buyer Documents"
          Title2="Seller Documents"
          Title3="Deal Documents"
        />
      ) : (
        ""
      )}

      {SellerRep === "Yes" &&
      IsDisclosure === "Personal Trade" &&
      BuyerRep === "Client" ? (
        ""
      ) : (
        <YTClauseCard
          ClauseCardDescription={clauseCardDesc.filter(
            (item) => item.category.includes("Single Family") === true
          )}
          ClauseDataCommon={clauseData.filter(
            (item) =>
              item.category.includes("Agricultural") === true &&
              item.isCommon === "yes"
          )}
          ClauseDataSituational={clauseData.filter(
            (item) =>
              item.category.includes("Agricultural") === true &&
              item.isCommon === "no"
          )}
        />
      )}

      <div className="important-notes flex flex-col w-full justify-left pt-6">
        <strong>Important Notes:</strong>
        <div className="pb-3"></div>
        {IsDisclosure === "Personal Trade" || IsDisclosure === "Indirect" ? (
          <ImportantNotes
            Notes={importantNotes.filter(
              (notes) => notes.category.includes("disclosurePurchase") === true
            )}
          />
        ) : (
          ""
        )}
        <ImportantNotes
          Notes={importantNotes.filter(
            (notes) => notes.category.includes("purchase") === true
          )}
        />
      </div>
      <BackToTop />
    </div>
  );
}
